export default __webpack_public_path__ + "static/media/logoProfectum.4c7a34d5.png";